
import Store from '../store/Store'
import Firestore from '@/data/Firestore'


export default class {

    //options can contain: timeout

    static saveFlow(flow) {
        flow._path = 'workflows'
        Firestore.saveItem(flow)
    }

    static fetchFlow(id) {
        const ref = Firestore.getDocumentRef('workflows/' + id)
        return Firestore.fetch(ref) //returns promise
    }

    static flowSummary(workflow) {
        return workflow.steps.map(step => {
            return {
                'title': StringHelpers.truncateDots(step.title, 10),
                'value': StringHelpers.truncateDots(step.value, 10),
                'type': step.type,
            }
        })
    }

    static getLastItem(objArr) {
        
    }

    static getIndex(item) {
        
    }
}


// WEBPACK FOOTER //
// ./src/flow/FlowHelpers.js